import { StanButton } from '@/components/core-components/StanButton/StanButton';
import { useUser } from '@/queries/useUser';
import { useState } from 'react';
import { ProductPayment } from '../types/transactionTypes';
import { createIconElement, GENERIC_STATUS, PAYMENT_STATUS } from '@/lib';
import { useStanRouter } from '@/hooks/useStanRouter';
import { downloadReceipt, sendReceipt } from '@/lib/api/income/api';
import IcEmail from '@/assets/icons/ic-mail-incoming.svg';
import IcDownload from '@/assets/icons/ic-download.svg';
import IcPerson from '@/assets/icons/ic-profile.svg';
import { StanTag } from '@/components';

export function GeneralButtonArea({ paymentData, paymentId }: { paymentData: ProductPayment; paymentId: string }) {
    const [sendReceiptLoading, setSendReceiptLoading] = useState(false);
    const [downloadReceiptLoading, setDownloadReceiptLoading] = useState(false);
    const { push } = useStanRouter();
    const { user } = useUser();

    const isPaidOut = paymentData?.status
        ? [
              PAYMENT_STATUS.CREATOR_FULFILLED,
              PAYMENT_STATUS.PAID_NOT_FULFILLED,
              PAYMENT_STATUS.DISPUTED,
              PAYMENT_STATUS.REFUNDED,
          ].includes(paymentData.status)
        : false;

    const isPaymentGatewayStripe =
        paymentData?.payment_gateway === 'stripe' || paymentData?.payment_gateway === 'stripe-checkout';

    const isReceiptAvailable = paymentData && paymentData.revenue !== 0 && isPaymentGatewayStripe && isPaidOut;
    const isCustomerActive = paymentData && paymentData.user_fan_status !== GENERIC_STATUS.DELETED;

    const handleSendReceiptDownload = () => {
        setSendReceiptLoading(true);
        if (user && paymentId) sendReceipt(user, paymentId).finally(() => setSendReceiptLoading(false));
    };

    const handleReceiptDownload = () => {
        setDownloadReceiptLoading(true);
        if (user && paymentId) downloadReceipt(user, paymentId).finally(() => setDownloadReceiptLoading(false));
    };

    const goToUserDetails = () => {
        if (paymentData?.user_fan_id) push(`/audience/details/${paymentData.user_fan_id}`);
    };

    const SendReceiptIcon = createIconElement(IcEmail);
    const DownloadReceiptIcon = createIconElement(IcDownload);
    const ViewCustomerIcon = createIconElement(IcPerson);

    return (
        <>
            {!isCustomerActive && <StanTag label='Customer Deleted' className='bg-negative-soft text-negative-bold' />}
            {isReceiptAvailable && (
                <StanButton
                    name='payment-details-send-receipt-button'
                    size='xs'
                    variant='outline'
                    color='secondary'
                    onClick={handleSendReceiptDownload}
                    loading={sendReceiptLoading}
                    icon={SendReceiptIcon}
                >
                    Send Receipt
                </StanButton>
            )}
            {isReceiptAvailable && (
                <StanButton
                    name='payment-details-download-receipt-button'
                    size='xs'
                    variant='outline'
                    color='secondary'
                    onClick={handleReceiptDownload}
                    loading={downloadReceiptLoading}
                    icon={DownloadReceiptIcon}
                >
                    Download Receipt
                </StanButton>
            )}
            {isCustomerActive && (
                <StanButton
                    name='payment-details-view-customer-button'
                    size='xs'
                    variant='outline'
                    onClick={goToUserDetails}
                    icon={ViewCustomerIcon}
                >
                    View Customer
                </StanButton>
            )}
        </>
    );
}
